import Vue from 'vue'
import Vuex from 'vuex'
import productList from './modules/productList'
import picList from './modules/picList'
import indexNavTabList from './modules/indexNavTabList'
import navData from './modules/navData'
import tabView from './modules/tabViews'
import cooperativeData from './modules/cooperativeData'
import activeProperty from './modules/activePropertyData'


Vue.use(Vuex);
export default new Vuex.Store({
    modules:{
        productList,
        picList,
        indexNavTabList,
        navData,
        tabView,
        cooperativeData,
        activeProperty
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js